import { IconSVG } from '../types';

export const Lock = ({ size, style }: IconSVG) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 22c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 014 20V10c0-.55.196-1.02.588-1.412A1.926 1.926 0 016 8h1V6c0-1.383.487-2.563 1.463-3.538C9.438 1.487 10.617 1 12 1s2.563.488 3.537 1.462C16.512 3.438 17 4.617 17 6v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v10c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0118 22H6zm0-2h12V10H6v10zm6-3c.55 0 1.02-.196 1.412-.587.392-.392.588-.863.588-1.413s-.196-1.02-.588-1.412A1.926 1.926 0 0012 13c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0010 15c0 .55.196 1.02.588 1.413.391.391.862.587 1.412.587zM9 8h6V6c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0012 3c-.833 0-1.542.292-2.125.875A2.893 2.893 0 009 6v2z" />
  </svg>
);
